<template>
    <div :key="key" class="radio-button-custom">
        <el-radio-group 
            v-model="_value" 
            v-bind="$attrs"
            v-on="$listeners"
        >
            <el-radio-button
                v-for="option in options"
                :key="option.value"
                :label="option.value"
            >
                {{ option.label }}
            </el-radio-button>
        </el-radio-group>
    </div>
</template>

<script>
export default {
  name: "RadioButtonCustom",
  
  inheritAttrs: false,

  props: {
    value: {
      default: "",
      type: [String, Number, Boolean]
    },
    options: {
      type: Array,
      require: true,
      default: () => []
    }
  },

  data() {
    return {
      key: `RadioButtonCustomID-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss">
.radio-button-custom {
  display: inline-block;
  .el-radio-group {
    .el-radio-button {
      margin: 0 10px 10px 0;
      .el-radio-button__inner {
        height: 24px;
        padding: 0 15px;
        color: #59687E;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        background-color: #fff;
        border-radius: 2px;
        border: 1px solid #CFD8E6;
        white-space: nowrap;
        &:hover {
            background-color: #258FF8;
            color: #fff;
            border-color: #258FF8;
        }
      }
    }
    .is-active {
      .el-radio-button__inner {
          background-color: #258FF8;
          color: #fff;
          border-color: #258FF8;
      }
    }
  }
}
</style>
